<template>
  <div class="app-version-container">
    <!-- 卡片容器 -->
    <el-card class="content-card" shadow="hover">
      <!-- 头部操作栏 -->
      <div class="header-operation">
        <div class="select-box">
          <el-select
            v-model="selectedAppId"
            placeholder="请选择软件"
            style="width: 350px;"
            @change="getVersionList"
            clearable
            size="medium"
          >
            <el-option
              v-for="item in appList"
              :key="item.appId"
              :label="item.appName"
              :value="item.appId"
            ></el-option>
          </el-select>
        </div>
        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="openAddDialog"
          size="medium"
          class="add-btn"
          :disabled="!selectedAppId"
        >
          新增版本
        </el-button>
      </div>

      <!-- 版本表格 -->
      <el-table
        :data="versionList"
        border
        stripe
        style="width: 100%; margin-top: 20px;"
        @row-dblclick="openEditDialog"
        :header-cell-style="{ background: '#f5f7fa', fontWeight: 'bold', color: '#303133' }"
        :cell-style="{ padding: '12px 0' }"
        empty-text="暂无版本数据，请先选择软件并新增版本"
        size="medium"
      >
      <el-table-column prop="id" label="ID" align="center" width="150">
          <template #default="scope">
            <span class="cell-text">{{ scope.row.id}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="version" label="版本号" align="center" width="150">
          <template #default="scope">
            <span class="cell-text">{{ scope.row.version }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="downloadUrl" label="下载地址" align="center" min-width="400">
          <template #default="scope">
            <el-link
              type="primary"
              :href="scope.row.downloadUrl"
              target="_blank"
              class="download-link"
            >
              {{ scope.row.downloadUrl }}
            </el-link>
          </template>
        </el-table-column>
        <!-- 修正问题 1：表格渲染改为 description（与后端一致） -->
        <el-table-column prop="description" label="更新描述" align="center" min-width="300">
          <template #default="scope">
            <span class="cell-text">{{ scope.row.description || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createUser" label="创建人" align="center" width="120">
          <template #default="scope">
            <span class="cell-text">{{ scope.row.createUser || 'admin' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center" width="200">
          <template #default="scope">
            <span class="cell-text">
              {{ scope.row.createTime ? new Date(scope.row.createTime).toLocaleString() : '-' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="是否最新" align="center" width="120">
          <template #default="scope">
            <!-- 修正问题 2：布尔值判断（true/false），与后端 Boolean 类型匹配 -->
            <el-tag
              type="success"
              size="mini"
              effect="dark"
              v-if="scope.row.isLatest === true"
            >
              最新版本
            </el-tag>
            <el-tag
              type="info"
              size="mini"
              v-else
            >
              普通版本
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="220">
          <template #default="scope">
            <el-button
              type="success"
              size="mini"
              icon="el-icon-edit"
              @click="openEditDialog(scope.row)"
              circle
            ></el-button>
            <!-- 修正问题 2：操作按钮的判断也改为布尔值 true -->
            <el-button
              type="warning"
              size="mini"
              icon="el-icon-star-on"
              @click="setAsLatest(scope.row.id)"
              circle
              style="margin-left: 8px;"
              v-if="scope.row.isLatest !== true"
            ></el-button>
            <el-button
              type="danger"
              size="mini"
              icon="el-icon-delete"
              @click="deleteVersion(scope.row.id)"
              circle
              style="margin-left: 8px;"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 新增/编辑版本弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="650px"
      close-on-click-modal="false"
      border-radius="12px"
    >
      <el-form
        :model="formData"
        label-width="100px"
        ref="versionFormRef"
        :rules="formRules"
        label-position="right"
        class="dialog-form"
      >
        <el-form-item label="软件ID" prop="appId">
          <el-input
            v-model="formData.appId"
            disabled
            size="medium"
            placeholder="软件ID自动填充"
          ></el-input>
        </el-form-item>
        <el-form-item label="版本号" prop="version">
          <el-input
            v-model="formData.version"
            size="medium"
            placeholder="请输入版本号（如：1.0.0）"
          ></el-input>
        </el-form-item>
        <el-form-item label="下载地址" prop="downloadUrl">
          <el-input
            v-model="formData.downloadUrl"
            size="medium"
            placeholder="请输入 http:// 或 https:// 开头的下载地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="更新描述" prop="description">
          <el-input
            type="textarea"
            v-model="formData.description"
            rows="4"
            size="medium"
            placeholder="请输入版本更新描述（可选）"
            resize="none"
          ></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button size="medium" @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" size="medium" @click="submitForm">确认提交</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'AppVersionManager',
  data() {
    return {
      appList: [],
      selectedAppId: '',
      versionList: [],
      dialogVisible: false,
      dialogTitle: '新增版本',
      isEdit: false,
      formData: {
        id: '',
        appId: '',
        version: '',
        downloadUrl: '',
        description: '', // 与后端字段一致
        createUser: 'admin'
      },
      formRules: {
        version: [
          { required: true, message: '请输入版本号', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符之间', trigger: 'blur' }
        ],
        downloadUrl: [
          { required: true, message: '请输入下载地址', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value && !value.startsWith('http://') && !value.startsWith('https://')) {
                callback(new Error('下载地址必须以 http:// 或 https:// 开头'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  mounted() {
    // 初始化加载软件列表（用于下拉选择）
    this.getAppList()
  },
  methods: {
    /**
     * 获取软件列表（无参数，直接请求）
     */
    getAppList() {
      this.request.get("/api/app/list").then(res => {
        if (res.code === '0' || res.code === 200) {
          this.appList = res.data || []
        } else {
          this.$message.error(res.msg || res.message || '获取软件列表失败')
        }
      }).catch(err => {
        this.$message.error('网络请求失败，请检查后端服务')
        console.error(err)
      })
    },

    /**
     * 获取版本列表（已修正 GET 请求参数格式）
     */
    getVersionList() {
      if (!this.selectedAppId) {
        this.versionList = []
        return
      }

      const params = {
        appId: this.selectedAppId
      }

      // 修正：GET 请求参数放入 { params } 中，适配 axios 规范
      this.request.get("/api/version/list", { params }).then(res => {
        if (res.code === '0' || res.code === 200) {
          this.versionList = res.data || []
        } else {
          this.$message.error(res.msg || res.message || '获取版本列表失败')
        }
      }).catch(err => {
        this.$message.error('网络请求失败，请检查后端服务')
        console.error(err)
      })
    },

    /**
     * 打开新增版本弹窗
     */
    openAddDialog() {
      this.dialogTitle = '新增版本'
      this.isEdit = false
      this.resetForm()
      this.formData.appId = this.selectedAppId
      this.dialogVisible = true
    },

    /**
     * 打开编辑版本弹窗
     */
    openEditDialog(row) {
      this.dialogTitle = '编辑版本'
      this.isEdit = true
      this.formData = { ...row }
      this.dialogVisible = true
    },

    /**
     * 重置表单
     */
    resetForm() {
      this.formData = {
        id: '',
        appId: this.selectedAppId,
        version: '',
        downloadUrl: '',
        description: '', // 修正问题 1：改为 description，与后端、表单绑定一致
        createUser: 'admin'
      }
      this.$refs.versionFormRef?.clearValidate()
    },

    /**
     * 提交版本表单（新增/编辑）
     */
    submitForm() {
      this.$refs.versionFormRef.validate((valid) => {
        if (!valid) {
          console.log('error submit!!')
          return false
        }

        if (this.isEdit) {
          // 编辑版本：PUT /version/update/{id}
          this.request.put(`/api/version/update/${this.formData.id}`, this.formData).then(res => {
            if (res.code === '0' || res.code === 200) {
              this.$message.success('编辑成功')
              this.dialogVisible = false
              this.getVersionList()
            } else {
              this.$message.error(res.msg || res.message || '编辑失败')
            }
          }).catch(err => {
            this.$message.error('提交失败，请检查网络')
            console.error(err)
          })
        } else {
          // 新增版本：POST /version/add
          this.request.post("/api/version/add", this.formData).then(res => {
            if (res.code === '0' || res.code === 200) {
              this.$message.success('新增成功')
              this.dialogVisible = false
              this.getVersionList()
            } else {
              this.$message.error(res.msg || res.message || '新增失败，版本号可能已存在')
            }
          }).catch(err => {
            this.$message.error('提交失败，请检查网络')
            console.error(err)
          })
        }
      })
    },

    /**
     * 设置为最新版本
     */
    setAsLatest(id) {
      if (!id) {
        this.$message.warning('无效的版本ID')
        return
      }

      this.$confirm(
        '确定要将该版本设为最新吗？原有最新版本会被取消！',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info',
          closeOnClickModal: false
        }
      ).then(() => {
        this.request.put(`/api/version/set-latest/${id}`).then(res => {
          if (res.code === '0' || res.code === 200) {
            this.$message.success('设置最新版本成功')
            this.getVersionList()
          } else {
            this.$message.error(res.msg || res.message || '设置失败')
          }
        }).catch(err => {
          this.$message.error('设置失败，请检查网络')
          console.error(err)
        })
      }).catch(() => {
        this.$message.info('已取消设置')
      })
    },

    /**
     * 删除版本
     */
    deleteVersion(id) {
      if (!id) {
        this.$message.warning('无效的版本ID')
        return
      }

      this.$confirm(
        '确定要删除该版本吗？删除后不可恢复！',
        '警告',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'danger',
          confirmButtonClass: 'el-button--danger',
          closeOnClickModal: false
        }
      ).then(() => {
        this.request.delete(`/api/version/delete/${id}`).then(res => {
          if (res.code === '0' || res.code === 200) {
            this.$message.success('删除成功')
            this.getVersionList()
          } else {
            this.$message.error(res.msg || res.message || '删除失败')
          }
        }).catch(err => {
          this.$message.error('删除失败，请检查网络')
          console.error(err)
        })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    }
  }
}
</script>

<style scoped>
/* 容器整体样式 */
.app-version-container {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: calc(100vh - 100px);
}

/* 卡片样式 */
.content-card {
  border-radius: 12px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
  border: none;
}

/* 头部操作栏 */
.header-operation {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
}

/* 新增按钮 */
.add-btn {
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 14px;
}

/* 表格单元格文本 */
.cell-text {
  color: #303133;
  font-size: 14px;
}

/* 下载地址链接 */
.download-link {
  font-size: 13px;
  word-break: break-all;
}

/* 弹窗表单 */
.dialog-form {
  padding: 10px 0;
}

/* 表单项间距 */
::v-deep .el-form-item {
  margin-bottom: 20px;
}

/* 弹窗圆角 */
::v-deep .el-dialog__header {
  padding: 20px 20px 16px;
}

::v-deep .el-dialog__body {
  padding: 16px 20px 20px;
}

::v-deep .el-dialog__footer {
  padding: 12px 20px 20px;
  text-align: right;
}

::v-deep .el-input__inner,
::v-deep .el-textarea__inner,
::v-deep .el-button,
::v-deep .el-select .el-input__inner {
  border-radius: 8px;
}

/* 标签样式优化 */
::v-deep .el-tag {
  border-radius: 4px;
}
</style>